module.exports = __webpack_public_path__ + "img/empty-heart.b9566ecf.png";